/**
 * Disconnect-confirm popup copy. Carved out of enIntegrations so that file
 * stays under the 500-line ratchet while every disconnect ask can share one
 * in-app dialog instead of native window.confirm.
 */
export const enDisconnect = {
  'integrations.disconnectConfirmCancel': 'Cancel',
  'integrations.disconnectConfirmYes': 'Disconnect',
  'integrations.disconnectConfirmWorking': 'Disconnecting…',
  'socialChannel.disconnectConfirmTitle': 'Disconnect {label}?',
  'socialChannel.disconnectConfirmBody':
    'Publishing and sync for this connection stop until you connect again.',
  'tiktokSettings.disconnectConfirmTitle': 'Disconnect TikTok?',
  'tiktokSettings.disconnectConfirmBody':
    'Publishing and sync stop until you connect again.',
  'salesforceSettings.disconnectConfirmTitle': 'Disconnect Salesforce?',
  'salesforceSettings.disconnectConfirmBody':
    'Contact and opportunity sync stop until you connect again.',
  'hubspotSettings.disconnectConfirmTitle': 'Disconnect HubSpot?',
  'hubspotSettings.disconnectConfirmBody':
    'Contact sync stops until you connect again.',
  'googleSheetsSettings.disconnectConfirmTitle': 'Disconnect Google Sheets?',
  'googleSheetsSettings.disconnectConfirmBody':
    'Sheet sync stops until you connect again.',
  'googleAdsSettings.disconnectConfirmTitle': 'Disconnect Google Ads?',
  'googleAdsSettings.disconnectConfirmBody':
    'Stored tokens will be removed and campaign sync stops until you connect again.',
} as const;
